import { Col, Typography } from "antd";
import { Link } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { VIEWS } from "../../../constants/global";

import { HEADER_OPENER, SOLOOP_LOGO } from "../../../constants/svgs";

import "./styles.mobile.scss";

const { Text } = Typography;

type HeaderMobileType = {
  isMenuOpen: boolean;
  toggleMenu: () => void;
};

const HeaderMobile = ({ isMenuOpen, toggleMenu }: HeaderMobileType) => {
  return (
    <>
      <Col span={6}>
        <Link to={routes[VIEWS.HOME].fullPath}>
          {SOLOOP_LOGO("167", "67.33")}
        </Link>
      </Col>
      <Col>
        <span
          className={`Header-opener ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
        >
          {HEADER_OPENER}
        </span>
      </Col>
      <Col span={24}>
        <div className={`Header-mobile-links ${isMenuOpen ? "active" : ""}`}>
          <Link
            to={routes[VIEWS.HOME].fullPath}
            className="Header-mobile-link-wrapper"
          >
            <Text className="Header-mobile-link">Start</Text>
          </Link>
          <Link
            to={routes[VIEWS.ABOUT_US].fullPath}
            className="Header-mobile-link-wrapper"
          >
            <Text className="Header-mobile-link">About</Text>
          </Link>
          <Link
            to={routes[VIEWS.SERVICES].fullPath}
            className="Header-mobile-link-wrapper"
          >
            <Text className="Header-mobile-link">Services</Text>
          </Link>
          <Link
            to={routes[VIEWS.OUR_WORK].fullPath}
            className="Header-mobile-link-wrapper"
          >
            <Text className="Header-mobile-link">Work</Text>
          </Link>
          <Link
            to={routes[VIEWS.CONTACT].fullPath}
            className="Header-mobile-link-wrapper"
          >
            <Text className="Header-mobile-link">Contact</Text>
          </Link>
        </div>
      </Col>
    </>
  );
};

export default HeaderMobile;
